// getOnSiteCampaign returns the active on-site campaigns for the requests page
export const PromotionsService_getOnSiteCampaignLazy = () =>
  import("./promotions_service.grpc").then(
    (m) => m.PromotionsService_getOnSiteCampaign
  );
PromotionsService_getOnSiteCampaignLazy.method =
  "promotions.v1.PromotionsService/getOnSiteCampaign" as const;
